@use "@fukuri-admins/ui/layout" as *;

.content {
  padding: spacing("24");
}
